// extracted by mini-css-extract-plugin
export default {"pagetemplate":"PageTemplate_pagetemplate__0BYrj","pagetemplate__content":"PageTemplate_pagetemplate__content__QJS52"};